import React from 'react';
/**
 * @ignore - internal component.
 */

var RadioGroupContext = React.createContext();
export default RadioGroupContext;